<template>
  <div class="r-text-body-small">
    <div class="row no-wrap">
      <span class="text-riseup-blue r-text-bold">{{ term }}</span>
      <span v-if="alternativeTerm" class="text-riseup-blue">&nbsp;({{alternativeTerm}})</span>
      <span>&nbsp;</span>
      <span class="text-riseup-blue">=</span>
      <span>&nbsp;</span>
      <span>{{ explanation }}</span>
    </div>
    <div v-if="subtext">{{ subtext }}</div>
  </div>
</template>

<script>
export default {
  name: 'Term',
  props: {
    term: {
      type: String,
      required: true,
    },
    explanation: {
      type: String,
      required: true,
    },
    alternativeTerm: String,
    subtext: String,
  },
};
</script>
